import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {getAllRoomBookings} from "./API";

export const getRoomBookingsThunk = createAsyncThunk(
    'roomBookings/getRoomBookings',
    async (spaceId) => {
        return getAllRoomBookings(spaceId)
    }
)

const RoomBookingsSlice = createSlice({
    name: 'roomBookings',
    initialState: {roomBookings: [], loading: 'idle'},
    reducers: {},
    extraReducers: {
        [getRoomBookingsThunk.pending]: (state, action) => {
            state.status = 'loading'
        },
        [getRoomBookingsThunk.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.error.message
        },
        [getRoomBookingsThunk.fulfilled]: (state, action) => {
            state.roomBookings = action.payload
        }
    }
})

export default RoomBookingsSlice.reducer
